<template>
  <!-- 0402 width 변경-->
  <w-sliding-popup ref="slidingPopup" :title="popupParams.popupTitle" width="1000px" @close="close">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step v-for="(step, index) in stepTitles[popupParams.popupType]" :key="index" :title="step"></el-step>
      </el-steps>
      <w-work-info-view ref="workInfo" v-show="activeStep === 1" :work-type-datas="popupParams.workTypeDatas" :work-impact-datas="popupParams.workImpactDatas" :popup-type="popupParams.popupType" />
      <w-work-target-view ref="workTarget" v-show="activeStep === 2" :active="active"></w-work-target-view>
      <w-work-time-view ref="workTime" v-show="activeStep === 3 && popupParams.popupType === 'ADD'" :selected-date="popupParams.selectedDate"></w-work-time-view>
      <w-work-info-check-form :form-datas="checkFormData" v-show="checkFormViewShow"></w-work-info-check-form>
    </div>
    <el-row slot="footer" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep !== 1" @click="prevStep">이전 단계</el-button>
      </div>
      <div>
        <el-button size="large" type="solid" v-if="activeStep === 4 && popupParams.popupType === 'ADD'" @click="addWork">등록</el-button>
        <el-button size="large" type="solid" v-else-if="activeStep === 3 && popupParams.popupType === 'UPDATE'" @click="updateWork">등록</el-button>
        <el-button size="large" type="solid" v-else @click="nextStep">다음 단계</el-button>
        <el-button size="large" @click="closePopup">취소</el-button>
      </div>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { assign, isNil, cloneDeep, snakeCase, isEmpty } from 'lodash';
import MsgUtil from '@/utils/message';
import workManageAPI from '@/api/work/work';
import WWorkInfoView from './components/WorkInfoView';
import WWorkTargetView from './components/WorkTargetView';
import WWorkTimeView from './components/WorkTimeView';
import WWorkInfoCheckForm from './components/WorkInfoCheckForm';

export default {
  name: 'WSettingWorkSlidingPopup',
  components: {
    WWorkInfoView,
    WWorkTargetView,
    WWorkTimeView,
    WWorkInfoCheckForm,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeStep: 1,
      workBasicInfo: {},
      workTime: {},
      stepTitles: {
        ADD: ['작업 정보', '대상 선택', '작업시간 설정', '확인'],
        UPDATE: ['작업 정보', '대상 선택', '확인'],
      },
      checkFormData: {},
      modifiedDataKeys: {},
      active: false,
    };
  },
  computed: {
    checkFormViewShow() {
      if (this.popupParams.popupType === 'ADD' && this.activeStep === 4) return true;
      else if (this.popupParams.popupType === 'UPDATE' && this.activeStep === 3) return true;
      return false;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    fileMaxMbSize() {
      return this.$store.state.common.fileMaxMbSize;
    },
  },
  methods: {
    onSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    open() {
      this.active = true;
      this.activeStep = 1;
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        if (this.popupParams.popupType === 'ADD') {
          this.$refs.workInfo.initWorkInfo();
          this.$refs.workTarget.initWorkTarget();
          this.$refs.workTime.initWorkTime();
        } else if (this.popupParams.popupType === 'UPDATE') {
          const params = this.popupParams.updateParams;
          this.$refs.workInfo.loadWorkInfo(params);
          this.$refs.workTarget.loadWorkTarget(cloneDeep(params));
        }
      });
    },
    close() {
      this.active = false;
      this.$refs.workTarget.initWorkTarget();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * '다음 단계' 버튼 클릭
     * @author kimjy
     */
    nextStep() {
      let resultVal = false;
      if (this.activeStep === 1) {
        const validation = this.$refs.workInfo.getWorkInfo();
        validation.validatePromise
          .then((response) => {
            if (response) {
              if (!isEmpty(validation.workBasicInfo.workInfo.fileInfo)) {
                const fileInfo = validation.workBasicInfo.workInfo.fileInfo;
                if (fileInfo.size > this.fileMaxMbSize * (10 ** 6)) {
                  this.$message('첨부 파일 용량을 확인해주십시오.');
                  return;
                }
              }
              this.workBasicInfo = validation.workBasicInfo;
              this.modifiedDataKeys = validation.modifiedDataKeys;
              this.activeStep = this.activeStep + 1;
            }
          })
          .catch(() => {
            this.$message('값을 입력해주십시오.');
          });
      } else if (this.activeStep === 2) {
        resultVal = this.$refs.workTarget.getWorkTarget();
        if (!resultVal || isNil(resultVal)) {
          this.$message('대상을 선택해주십시오.');
        } else {
          this.workTarget = resultVal.objList;
          if (this.popupParams.popupType === 'UPDATE') {
            this.checkFormData = cloneDeep(this.workBasicInfo.workInfo);
            assign(this.checkFormData, {
              managerList: this.workBasicInfo.managerList,
              objList: this.workTarget,
            });
            // 수정된 objlist
            if (resultVal.modifiedObjDatas) assign(this.modifiedDataKeys, { objList: resultVal.modifiedObjDatas });
          }
          this.activeStep = this.activeStep + 1;
        }
      } else if (this.activeStep === 3 && this.popupParams.popupType === 'ADD') {
        resultVal = this.$refs.workTime.getWorkTime();
        if (!resultVal || isNil(resultVal)) {
          this.$message('작업 시간을 올바르게 설정해주십시오.');
        } else {
          this.workTime = resultVal;

          this.checkFormData = cloneDeep(this.workBasicInfo.workInfo);
          assign(this.checkFormData, {
            scheduleDetail: this.workTime.scheduleDetail,
            managerList: this.workBasicInfo.managerList,
            objList: this.workTarget,
          });

          this.activeStep = this.activeStep + 1;
        }
      }
    },
    /**
     * '이전 단계' 버튼 클릭
     * @author kimjy
     */
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    /**
     * '등록' 버튼 클릭 (작업 추가)
     * @author kimjy
     */
    addWork() {
      const workBasicInfo = this.workBasicInfo;
      const workTarget = this.workTarget;
      const workTime = this.workTime;
      const fileInfo = workBasicInfo.workInfo.fileInfo;

      const maintenanceList = [];
      this.workBasicInfo.maintenanceList.forEach((data) => {
        if (!('blankFlag' in data)) {
          maintenanceList.push(data);
        }
      });

      // contentType 설정
      const params = new FormData();
      params.append('file', fileInfo);
      params.append('workInfo', JSON.stringify(workBasicInfo.workInfo));
      params.append('managerList', JSON.stringify(workBasicInfo.managerList));
      params.append('maintenanceList', JSON.stringify(maintenanceList));
      params.append('workTarget', JSON.stringify(workTarget));
      params.append('workTime', JSON.stringify(workTime));

      const target = '작업';
      workManageAPI
        .addWork(params)
        .then((response) => {
          if (response.data.success === true) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.ADD, target, true));
            this.closePopup();
            this.$emit('close');
          } else {
            this.$message(MsgUtil.getCustomResultMsgData(response.data.message, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.ADD, target, false));
        });
    },
    /**
     * '등록' 버튼 클릭 (작업 변경)
     * @author jeee12
     */
    updateWork() {
      const modifiedDataKeys = this.modifiedDataKeys; // 수정된 key, flag
      const workSeqNumber = this.popupParams.updateParams.workSeqNumber;
      const workName = this.workBasicInfo.workInfo.workName; // 작업변경 타임라인 호출 위한 param
      const workBasicInfo = this.workBasicInfo; // 수정된 data
      const params = { workSeqNumber, workName, modifiedWorkInfoList: [] };
      let modifiedFlag = false;

      if (modifiedDataKeys.workInfo.length > 0) {
        // 기본정보
        const workInfoList = [];
        // 수정된 key
        modifiedDataKeys.workInfo.forEach((key) => {
          if (key === 'workImpact' && workBasicInfo.workInfo[key] === 'GRADE_NULL') {
            workBasicInfo.workInfo[key] = null; // '영향도 없음'은 null로 수정
          }
          workInfoList.push({ key: snakeCase(key), value: workBasicInfo.workInfo[key] });
        });
        params.modifiedWorkInfoList = workInfoList;
        modifiedFlag = true;
      }
      if (modifiedDataKeys.managerList) {
        // 작업 담당자
        const managerList = [];
        workBasicInfo.managerList.forEach((manager) => {
          managerList.push({ managerId: manager.managerId, workSeqNumber });
        });
        params.managerList = managerList;
        modifiedFlag = true;
      }
      if (modifiedDataKeys.maintenanceList) {
        // 유지보수 업체
        const maintenanceList = [];
        workBasicInfo.maintenanceList.forEach((data) => {
          if (!('blankFlag' in data)) {
            data.workSeqNumber = workSeqNumber;
            maintenanceList.push(data);
          }
        });
        params.maintenanceList = maintenanceList;
        modifiedFlag = true;
      }
      if (modifiedDataKeys.objList) {
        // 작업대상
        modifiedDataKeys.objList.forEach((obj) => {
          obj.workSeqNumber = workSeqNumber;
        });
        params.workTarget = modifiedDataKeys.objList;
        modifiedFlag = true;
      }

      if (modifiedFlag) {
        params.modifiedWorkInfoList.push({
          key: 'manager_id',
          value: this.userInfo.managerId,
        });

        const target = '작업';
        workManageAPI
          .updateWork(params)
          .then((response) => {
            if (response.data.success === true) {
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.MODIFY, target, true));
              this.closePopup();
              this.$emit('close');
            } else {
              this.$message(MsgUtil.getCustomResultMsgData(response.data.message, false));
            }
          })
          .catch(() => {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.MODIFY, target, false));
          });
      } else {
        this.closePopup();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/popup/SettingWorkSlidingPopup.vue